import { gql } from '@apollo/client';

export const BILLING_PORTAL_URL = gql`
  mutation BillingPortalUrl {
    billingPortalUrl
  }
`; 